import { AfterViewInit, Component, ChangeDetectionStrategy } from '@angular/core';
import * as CookieConsent from 'vanilla-cookieconsent';

import { COOKIE_CONSENT_CONFIG } from './core/cookie-consent.config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AppComponent implements AfterViewInit {
  title = 'aa-web-portal';

  ngAfterViewInit(): void {
    CookieConsent.run(COOKIE_CONSENT_CONFIG);
  }
}